<template>
  <div>
    <loading 
      :active.sync="isLoading" 
      color="#64B9B0"
    ></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Denúncias</li>
        </ol>

        <div class="box_general padding_bottom">
          <div class="row">
            <div class="col-md-3 form-group">
              <label>Unidade</label>
              <v-select
                label="nome_unidade"
                v-model="obj.unidade"
                class="form-select"
                :reduce="unidades => unidades.id"
                :options="unidades"
                :searchable="true"
              >
              </v-select> 
            </div>
            <div class="col-md-3 form-group">
              <label>Tipo de Denúncia</label>
              <v-select
                label="tipo"
                v-model="obj.tipo_denuncia"
                class="form-select"
                :reduce="tipos_denuncia => tipos_denuncia.id"
                :options="tipos_denuncia"
                :searchable="true"
              >
              </v-select> 
            </div>
            <div class="col-md-3 form-group">
              <label>Status</label>
              <v-select
                label="status"
                v-model="obj.status"
                class="form-select"
                :reduce="status => status.id"
                :options="status"
                :searchable="true"
              >
              </v-select> 
            </div>
            <div class="col-md-3">
              <div class="pull-right">
                <button href="#0" class="btn_1 medium pull-right" @click="buscaInformacoes()">Filtrar Denúncias</button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-3">
              <label>Data Início</label>
              <date-picker
                v-model="obj.data_inicio" 
                :lang="lang"
                format="DD/MM/YYYY"
                type="date"
              ></date-picker>
            </div>
            <div class="form-group col-md-3">
              <label>Data Fim</label>
              <date-picker
                v-model="obj.data_fim" 
                :lang="lang"
                format="DD/MM/YYYY"
                type="date"
              ></date-picker>
            </div>
            <div class="col-md-3 form-group">
              <label>Protocolo</label>
              <input
                type="text"
                class="form-control"
                v-model="obj.protocolo"
              />
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div v-if="showRelatorio">
            <div class="row">
              <div class="col-md-12 ">
                <div class="pull-right">
                  <button @click="exportarXlsx()" class="btn_1 medium mb-3">Exportar Denúncias</button>
                </div>
              </div>
            </div>
            <v-card-title>
              <h3>Denúncias</h3>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Filtrar"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>

            <v-data-table rows-per-page-text="Linhas por Página" :no-data-text="textoTabela" :disable-initial-sort="true" 
            :headers="hasUnidades ? headers : headers2" :items="denuncias" :search="search" :pagination.sync="pagination">
              <template slot="items" slot-scope="props">
                <td>{{ padronizaDataHora(props.item.created_at) }}</td>
                <td v-if="hasUnidades">{{ props.item.nome_unidade }}</td>
                <td>{{ props.item.tipo_denuncia }}</td>
                <td>{{ props.item.status_atual }}</td>
                <td>{{ props.item.protocolo }}</td>
                <td></td>
                <td class="text-xs-right many-buttons">
                  <span v-if="!(props.item.deleted_at)">
                    <router-link
                      class="btn mr-2 text-white blue-grey darken-4"
                      :to="'denuncias/'+props.item.id"
                    >
                      <i class="fa fa-eye"></i> Detalhes
                    </router-link>
                  </span>
                </td>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Sua consulta para "{{ search }}" não teve resultado.</v-alert>
            </v-data-table>
          </div>
        </div>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import funcoesGerais from "@/assets/js/funcoes.js";
import { tratamento_requisicao, alerta, verificaSeEstaLogado } from "@/utils/util";
import axios from 'axios';
import DatePicker from 'vue2-datepicker';
import { json2excel } from 'js2excel';

export default {
  components: {DatePicker},
  mixins: [funcoesGerais],
  data() {
    return {
      isLoading: false,
      hasUnidades: false,
      denuncias: [],
      unidades: [],
      showRelatorio: true,
      search: "",
      pagination: {
        rowsPerPage: 5
      },
      obj: {
        data_inicio: null,
        data_fim: null,
        unidade: null,
        tipo_denuncia: null,
        status: null,
        protocolo: null
      },
      headers: [
        { text: "Data", value: "created_at" },
        { text: "Unidade", value: "nome_unidade" },
        { text: "Tipo de Denúncia", value: "tipo_denuncia" },
        { text: "Status", value: "status_atual" },
        { text: "Protocolo", value: "protocolo" }
      ],
      headers2: [
        { text: "Data", value: "created_at" },
        { text: "Tipo de Denúncia", value: "tipo_denuncia" },
        { text: "Status", value: "status_atual" },
        { text: "Protocolo", value: "protocolo" }
      ],
      tipos_denuncia: [
        { tipo:'Todos', id: 0},
        { tipo:'Assédio Moral', id: 1},
        { tipo:'Assédio Sexual', id: 2},
        { tipo:'Descumprimento de Normas', id: 3},
        { tipo:'Fraude/Corrupção/Suborno', id: 4},
        { tipo:'Outros', id: 5}
      ],
      status: [
        { status:'Todos', id: 0},
        { status:'Recebida', id: 1},
        { status:'Em Análise', id: 2},
        { status:'Finalizada', id: 3},
        { status:'Procedente', id: 4},
        { status:'Improcedente', id: 5},
        { status:'Inconclusiva', id: 6}
      ]
    };
  },

  created() {
    let self = this;
    self.isLoading = true;
    let user = verificaSeEstaLogado();

    if(user.role == 2) {
        self.isLoading = false;
    } else {
      self.isLoading = false;
      alerta("error", "Usuário não autorizado")
      self.$router.replace(this.$route.query.redirect || "/login")
    }

    axios.get(`empresas/${user.empresas_id}}`)
      .then(res => {
        this.hasUnidades = res.data.unidade_vinculada
      }
    )
  },

  mounted() {
    axios.get('unidades')
      .then((res) => {
        this.isLoading = false;
        this.unidades = res.data
        this.unidades.push({
          nome_unidade: 'Todos',
          id: 0
        })

      }, err => {
        this.isLoading = false;
        tratamento_requisicao(err);
      })
    this.buscaInformacoes();
  },
  
  methods: {
    async buscaInformacoes() {
      let self = this;
      self.isLoading = true;
      self.denuncias = [];
      
      await axios.post(`filtro_denuncias`, self.obj)
        .then((res) => {
          self.denuncias = res.data
          self.isLoading = false;

        }, err => {
          self.isLoading = false;
          tratamento_requisicao(err);
        })
   
        self.denuncias.forEach(item => {
          let temp = self.tipos_denuncia.find(s => s.id === item.tipo_denuncia)
          let temp2 = self.status.find(s => s.id === item.status_atual)
          item.tipo_denuncia = temp.tipo
          item.status_atual = temp2.status
        })

      self.isLoading = false;
    },
    exportarXlsx() {
      try {
        json2excel({
            data: this.denuncias,
            name: 'denuncia-info-data',
            formateDate: 'dd/mm/yyyy'
        });
      } catch (e) {
        tratamento_requisicao('error', 'Houve um erro ao exportar o arquivo')
      }
    }
  }
};
</script>